// Map actions.
export const ADD_LAYER = 'ADD_LAYER';
export const REMOVE_LAYER = 'REMOVE_LAYER';
export const RESET_LAYERS = 'RESET_LAYERS';
export const STORE_ALL_LAYERS = 'STORE_ALL_LAYERS';
export const TOGGLE_ZONING_LAYERS = 'TOGGLE_ZONING_LAYERS';
export const SWITCH_LAYERS = 'SWITCH_LAYERS';
export const CONTROL_CHECKED_LAYERS = 'CONTROL_CHECKED_LAYERS';
export const LAYERS_UPDATE_DONE = 'LAYERS_UPDATE_DONE';
export const LAYERS_UPDATE_START = 'LAYERS_UPDATE_START';
export const SWITCH_LAYERS_LEGEND = 'SWITCH_LAYERS_LEGEND';
export const SET_LAYERS_JURISDICTIONS = 'SET_LAYERS_JURISDICTIONS';
export const FETCH_MAP_DATA = 'FETCH_MAP_DATA';
export const SET_PROPERTY_POPUP_DATA = 'SET_PROPERTY_POPUP_DATA';
export const SET_MAP_GEOMETRY = 'SET_MAP_GEOMETRY';
export const SET_MODE_3D = 'SET_MODE_3D';
export const RESET_BUILDINGS = 'RESET_BUILDINGS';
export const FETCH_USER_SAVED_LAYER_TEMPLATES = 'FETCH_USER_SAVED_LAYER_TEMPLATES';
export const CURRENT_LAYER_TEMPLATE = 'CURRENT_LAYER_TEMPLATE';
export const FETCH_USER_SAVED_BUILDINGS_TEMPLATES = 'FETCH_USER_SAVED_BUILDINGS_TEMPLATES';
export const CURRENT_BUILDINGS_TEMPLATE = 'CURRENT_BUILDINGS_TEMPLATE';
export const SET_MAP_FORM_DATA = 'SET_MAP_FORM_DATA';
export const SUBMIT_MAP_SEARCH = 'SUBMIT_MAP_SEARCH';
export const UPDATE_MAP_SEARCH_RESULTS = 'UPDATE_MAP_SEARCH_RESULTS';
export const RESET_MAP_SEARCH_RESULTS = 'RESET_MAP_SEARCH_RESULTS';
export const UPDATE_LIST_RESULTS = 'UPDATE_LIST_RESULTS';
export const SET_FILTERS_LAST_VALUE_USE = 'SET_FILTERS_LAST_VALUE_USE';
export const SET_GRID_INITIALIZED = 'SET_GRID_INITIALIZED';
export const SET_PLACE_BOUNDARY = 'SET_PLACE_BOUNDARY';
export const FETCH_USER_SAVED_FILTERS_TEMPLATES = 'FETCH_USER_SAVED_FILTERS_TEMPLATES';
export const FETCH_PLACES = 'FETCH_PLACES';
export const CURRENT_FILTERS_TEMPLATE = 'CURRENT_FILTERS_TEMPLATE';
export const UPDATE_FACETS = 'UPDATE_FACETS';
export const SET_PROPERTY_LISTS = 'SET_PROPERTY_LISTS';
export const SET_SELECTED_PROPERTY_ROWS = 'SET_SELECTED_PROPERTY_ROWS';
export const GET_TRANSIT_TYPES = 'GET_TRANSIT_TYPES';
export const GET_POI_CATEGORIES = 'GET_POI_CATEGORIES';
export const GET_JURISDICTIONS = 'GET_JURISDICTIONS';
export const OPENED_PROPERTY_STATE = 'OPENED_PROPERTY_STATE';
export const SET_RECENT_PROPERTIES = 'SET_RECENT_PROPERTIES';
export const SET_FOLLOWED_PROPERTIES = 'SET_FOLLOWED_PROPERTIES';
export const FETCH_FOLLOWED_PROPERTIES = 'FETCH_FOLLOWED_PROPERTIES';
export const SET_PROPERTIES_NOTE_DATA = 'SET_PROPERTIES_NOTE_DATA';
export const FETCH_RECENT_ADDITIONS = 'FETCH_RECENT_ADDITIONS';
export const SET_UPDATE_PARAM_MAP = 'SET_UPDATE_PARAM_MAP';
export const INIT_CLUSTERS = 'INIT_CLUSTERS';
export const SET_NAVIGATION_PROPERTY = 'SET_NAVIGATION_PROPERTY';
export const SET_NAVIGATION_PLACE = 'SET_NAVIGATION_PLACE';
export const SET_NAVIGATION_STATE = 'SET_NAVIGATION_STATE';
export const SET_NAVIGATION_COUNTY = 'SET_NAVIGATION_COUNTY';
export const SET_SHORT_URL_MODE = 'SET_SHORT_URL_MODE';

// UI actions.
export const TOGGLE_LEFT_OVERLAY = 'TOGGLE_LEFT_OVERLAY';
export const SET_LOADING = 'SET_LOADING';
export const SET_MOBILE = 'SET_MOBILE';
export const SET_HEADER_UPDATING = 'SET_HEADER_UPDATING';
export const TOGGLE_MENU_COLLAPSE = 'TOGGLE_MENU_COLLAPSE';
export const SET_POPUP_STATE = 'SET_POPUP_STATE';
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const SET_MAP_STYLE = 'SET_MAP_STYLE';
export const SET_BREADCRUMBS = 'SET_BREADCRUMBS';
export const ADD_BREADCRUMB = 'ADD_BREADCRUMB';
export const SET_DOWNLOAD_PROGRESS = 'SET_DOWNLOAD_PROGRESS';

// User actions.
export const FETCH_USER_DATA = 'FETCH_USER_DATA';
export const SET_USER_DATA = 'SET_USER_DATA';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const SET_USER_SETTINGS = 'SET_USER_SETTINGS';
export const SESSION_DATA_RESTORED = 'SESSION_DATA_RESTORED';
export const SET_SUBSCRIPTION_SETTINGS = 'SET_SUBSCRIPTION_SETTINGS';

// Document actions.
export const SET_DOC_DETAILS = 'SET_DOC_DETAILS';
export const SET_SELECTED_ITEM = 'SET_SELECTED_ITEM';
export const SET_EDITOR = 'SET_EDITOR';
export const SET_EDITOR_CHANGES = 'SET_EDITOR_CHANGES';
export const SET_DOC_SEARCH_MODE = 'SET_DOC_SEARCH_MODE';
export const SET_DOC_SEARCH_PARAMS = 'SET_DOC_SEARCH_PARAMS';
export const SET_BOOKMARKS = 'SET_BOOKMARKS';
export const SET_PAGE_DATA = 'SET_PAGE_DATA';
export const SET_SHARED_FOLDER_MODE = 'SET_SHARED_FOLDER_MODE';
export const SET_DOC_TREE_DATA = 'SET_DOC_TREE_DATA';
export const REMOVE_TREE_ARTICLE = 'REMOVE_TREE_ARTICLE';

// Common actions
export const SET_COMMON_DATA = 'SET_COMMON_DATA';

// CRM actions
export const SET_COMPANY_DATA = 'SET_COMPANY_DATA';
